exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".liveStop[data-v-9486f75a]{margin-top:250px;text-align:center}.liveStop .buttom[data-v-9486f75a]{width:200px;height:40px;line-height:40px;display:inline-block;text-align:center;background:#3844e8;font-size:20px;color:#fff;border-radius:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-9486f75a","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Modular/livestop.vue
// module id = 543
// module chunks = 0